import { render } from "./MapInfo.vue?vue&type=template&id=35cbe49e"
import script from "./MapInfo.vue?vue&type=script&lang=js"
export * from "./MapInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__